import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import AddLeadstatusbox from './Adminleadstatus';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Popup from 'reactjs-popup';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';
let strCust=[{title:'',year:0}];
const headCells = [
  { id: 'ldm_firstname', numeric: false, label: 'Name' },
  { id: 'ldm_emailid', numeric: false, label: 'Email ID' },
  { id: 'ldm_phoneno', numeric: false, label: 'Phone No.' },
    { id: 'Type', numeric: false, label: 'Type' },
	 { id: 'followupdate', numeric: false, label: 'Followup Date' },
	 { id: 'leadesource', numeric: false, label: 'Source' },
	  { id: 'expirydate', numeric: false, label: 'Expiry Date' },
	   { id: 'st_name', numeric: false, label: 'Lead Owner' },
   { id: '',  label: '' },
  ]
  const headCellstatus = [
{ id: '', numeric: false, label: '' },
{ id: 'followupdate', numeric: false, label: 'Followup Date' },
{ id: 'type', numeric: false, label: 'Type' },
,
]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
/*new table head for display payment*/
function EnhancedTableHeadstatus(props) {
	const { classes, order, orderBy, rowCount, onRequestSort } = props;
	const createSortHandler = property => event => {
	onRequestSort(event, property);
};
return (
<TableHead>
<TableRow>
{headCellstatus.map(headCell => (
<TableCell
key={headCell.id}
align={headCell.numeric ? 'right' : 'left'}
padding={headCell.disablePadding ? 'none' : 'default'}
sortDirection={orderBy === headCell.id ? order : false}
>
<TableSortLabel
active={orderBy === headCell.id}
direction={orderBy === headCell.id ? order : 'asc'}
onClick={createSortHandler(headCell.id)}
>
{headCell.label}
{orderBy === headCell.id ? (
<span className={useStyles.visuallyHidden}>
{order === 'desc' ? ' ' : ' '}
</span>
) : null}
</TableSortLabel>
</TableCell>
))}
</TableRow>
</TableHead>
);
}
EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
/*new status section*/
EnhancedTableHeadstatus.propTypes = {
	classes: PropTypes.object.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};
/*end of new status section*/
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: '1 1 100%',
  },
}));
const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  };
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
const style = ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
});
export default class AdminLeadmaster extends Component {
    constructor(props) {
    super(props);
      this.state = {redirect: false,
      Leadmasterdata:[],ldmid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],ldcuid:0,ldm_leadsource:'',invoicedate:dayjs(Date.now()),invoicedate1:'',invoicetodate1:'',invoicetodate:dayjs(Date.now()),
	  order:'desc' ,orderBy:'',names:'',searchsubscription:'',type:'', open : true,setOpen:false     
      };
       this.updateDonenewParent = this.updateDonenewParent; 	   
	}
updateDonenewParent = (text) => {this.componentDidMount();}	  
componentDidUpdate() {			
		if(this.state.prevpage !== this.state.page) {
			this.setState({prevpage: this.state.page});
			this.apicall(this.state.page, localStorage.getItem("page"));  
		}
	}
	componentDidMount  () {	
	document.title = "AthaYog Living - Lead Management";
	if(localStorage.getItem("AYLuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
  this.apicall(this.state.page,this.state.rowsPerPage);
} 
 handleClickSearch=()=>{ 
this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Leadmasterdata:[],Data:[],
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
} 
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
}
apicall(page,rowsPerPage){
	 axios.get(Serverurl+'ajaxleadmaster.php?action=getall&ldm_firstname='+this.state.names+'&ldm_type='+this.state.type+'&ldm_leadsource='+this.state.ldm_leadsource+'&ldm_fromdate='+this.state.invoicedate1+'&ldm_todate='+this.state.invoicetodate1+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Leadmasterdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
		    });
     }
	 else{
		   this.setState({Leadmasterdata:[],totaldata:0});
	 }
    });
}
handdateChanges = (date) => {
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 todate1.setDate(date1.getDate() + 1);
     this.setState({ invoicedate:dayjs(date),
invoicedate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
invoicetodate: todate1,
invoicetodate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
  }
  handtodateChanges = (date) => {
	  var month="";
 var date1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ invoicetodate:dayjs(date),
invoicetodate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
  }
handleChangePage = (event, newPage) => {  
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
  };   
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
  };
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
  });
};
Leadstatusaddbox(val,cuid){
        this.setState({ ldmid:val,ldcuid:cuid});  
         setTimeout(() => this.refs.AddLeadstatusbox.handleLeadStatus(),500);
      }
      LaeadmasterDelete(ldmid){  
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('ldm_id',ldmid)
	formData.append('userid',localStorage.getItem("AYLuserid"))
	 axios.post(Serverurl+"ajaxleadmaster.php", formData, {
        }).then(res => {
             this.apicall(this.state.page,this.state.rowsPerPage);
							});
 }
      }
render() {
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  return (
  <React.Fragment>
<div className="boxheading">
<h2>Leads Management</h2>
</div>
<div className="addandbacbtn"><a href='/Addleadmaster' >New</a></div>
 <div className="clear"></div>
   <div className="searchmaster">
  <ul>
 <li>
 <p>Name/ Email id/ Phone No.</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="names" onChange={this.myChangeHandler} className="txtbox"
          /></p></li>
		<li>
 <p>From Date</p>
<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicedate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
  <li>
 <p>To Date</p>
<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicetodate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
	<li>
	 <p>Lead Type</p>
	<p><FormControl  className="stadrp">
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} className="txtbox"
          id="type"
		   value={this.state.type} inputProps={{tabIndex: "2"}}
		  name="type"
        >
	<option value="">Select Type</option>
           <option value={1}>Active</option>
          <option value={2}>In Active</option>
 <option value={3}>Follow Up</option>
 <option value={4}>Enquiry</option>
 <option value={5}>Lost</option>
        </Select>
		</FormControl>
		</p>
	</li>
<li>		
		<p> <span className="validation">*</span> Source</p>				  
						  <p><FormControl  className="stadrp">
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.ldm_leadsource} inputProps={{tabIndex: "9"}} className="txtbox"
		  name="ldm_leadsource"
        >
	<option value="">Select Source</option>
           <option value={1}>Website
</option>
          <option value={2}>
IVR</option>
          <option value={3}>Google</option>
          <option value={4}>Social media</option>
          <option value={5}>Referral</option>
          <option value={6}>Walk In</option>
          <option value={7}>Hoarding</option>
		    <option value={9}>App</option>
          <option value={8}>Others</option>
        </Select>
		</FormControl>
		</p>
		</li>	
		<li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> 
	  </p></li> 
		</ul>
</div>		
<AddLeadstatusbox ref="AddLeadstatusbox" cuid={this.state.ldcuid} id={this.state.ldmid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                      </TableRow></TableHead>
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Leadmasterdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Leadmasterdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
<TableCell>{item.ldm_firstname}</TableCell>
<TableCell>{item.ldm_emailid}</TableCell>
<TableCell>{item.ldm_phoneno}</TableCell>
<TableCell>{item.type}</TableCell>
<TableCell>{item.followupdate}</TableCell>
<TableCell>{item.leadesource}</TableCell>
<TableCell>{item.expirydate}</TableCell>
<TableCell>{item.st_name}</TableCell>
<TableCell align="left">
<div className="actionbtns">
<a href={'/Addleadmaster?Ldmid='+item.ldm_id}>
<Button variant="text"  className="frmSecondarybtn"   startIcon={<EditIcon />}>
Edit
</Button></a>&nbsp;&nbsp;
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.LaeadmasterDelete(item.ldm_id)}} endIcon={<DeleteIcon />} >
  Delete
</Button>&nbsp;&nbsp;
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Leadstatusaddbox(item.ldm_id,item.ldm_cu_id)}}>
        Lead Status
      </Button>
 </div>
 </TableCell>
 </TableRow>
 </React.Fragment>	
);
					})}
					{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
                      </TableBody>
</Table>
  </TableContainer> 
  <TablePagination  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
 </React.Fragment> 
  );
}
}